import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import Loader from '../Components/Loader';
import size from '../Assets/Screenshot_2024-11-28_123540-removebg-preview.png';
import size1 from '../Assets/person.png';
import size2 from '../Assets/room.png';
import {baseUrl} from "../Common/data"

function AllWaitlist() {
  const [wishlistHotels, setWishlistHotels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const token = localStorage.getItem("token");

  const fetchWishlist = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        // 'https://tripolo-backend.vercel.app/api/wishlist'
        `${baseUrl}/api/wishlist`
        , {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      const wishlist = res.data.data || [];

      // If backend returns hotel data directly, skip this
      // Otherwise populate hotel details via hotelId
      const hotels = wishlist.map(item => item.hotelId);
      setWishlistHotels(hotels);
    } catch (err) {
      console.error(err);
      setError('Failed to load wishlist.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWishlist();
  }, []);

  const handleRemove = async (hotelId) => {
    try {
      await axios.delete(
        // 'https://tripolo-backend.vercel.app/api/wishlist/remove'
        `${baseUrl}/api/wishlist/remove`
        , {
        headers: { Authorization: `Bearer ${token}` },
        data: { hotelId }
      });
      setWishlistHotels(prev => prev.filter(hotel => hotel._id !== hotelId));
    } catch (err) {
      console.error('Error removing from wishlist:', err);
    }
  };

  const handleBook = (id) => {
    window.location.href = `/collectiondetail/${id}`; // Or use navigate if you prefer
  };

  return (
    <>
      <Navbar />
      <div className="col-banner col-banner2">
        <div className="search-bar search-bar2">
          <h2>Your Wishlist</h2>
        </div>
      </div>

      {loading ? (
        <div className="loader-container">
          <Loader />
        </div>
      ) : error ? (
        <p className="error-message">{error}</p>
      ) : (
        <div className="trending-cards2 trending-cards3 trending-cards111">
          <div className="az">
            {wishlistHotels.length === 0 ? (
              <p style={{ textAlign: "center", padding: "2rem" }}>
                No hotels in your wishlist.
              </p>
            ) : (
              wishlistHotels.map((hotel) => (
                <div key={hotel._id} className="trending-card trending-card2">
                  <img src={hotel.images?.profile} alt={hotel.propertyName} />
                  <div className="trending-text">
                    <h3>{hotel.propertyName}</h3>
                    <div className="trending-text-line">
                      <p>
                        <i className="bi bi-geo-alt-fill"></i>{" "}
                        {hotel.location?.city}, {hotel.state}
                      </p>
                    </div>
                    <div className="trending-text-line2">
                      <p>
                        <img src={size1} alt="Guest capacity" />{" "}
                        <b>{hotel.guestCapacity}</b>
                      </p>
                      <p>
                        <img src={size2} alt="Total rooms" />{" "}
                        <b>{hotel.totalRooms} {hotel.totalRoomsType === "beds" ? "Beds" : "Rooms"}</b>
                      </p>
                      <p>
                        <img src={size} alt="Pool size" />{" "}
                        <b>
                          {hotel.poolSize?.length} X {hotel.poolSize?.breadth}
                        </b>
                      </p>
                    </div>
                    <div className="trending-text-line">
                      <h2>
                        ₹ {hotel?.listingprice || ""}{" "}
                        <span>
                          /{" "}
                          {hotel?.priceType === "per_person"
                            ? "Person"
                            : "Night"}
                        </span>
                      </h2>
                      {/* {hotel.rates.length > 0 && (
                  <h2>
                    ₹ {hotel.listingprice || hotel.rates[0].weekend} <span>/ night</span>
                  </h2>
                )} */}
                      <button onClick={() => handleBook(hotel._id)}>
                        Book Now
                      </button>
                      <button
                        onClick={() => handleRemove(hotel._id)}
                        style={{ backgroundColor: "red", marginLeft: "10px" }}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
      <Footer />
    </>
  );
}

export default AllWaitlist;
